
 import React, { useEffect, useRef } from 'react';
 import './Clock.css';
 
 const Clock = () => {
 
   const dateRef = useRef(null);
 
   useEffect(
     () => {
       //console.log('Clock() Start interval');
       if (dateRef && dateRef.current) {
        const time = new Date().toLocaleString('en-US', { hour: 'numeric', minute:'numeric', hour12: true });
        dateRef.current.innerHTML = time;
       }

       const timer = setInterval(() => {
         if (dateRef && dateRef.current) {
            const time = new Date().toLocaleString('en-US', { hour: 'numeric', minute:'numeric', hour12: true });
            dateRef.current.innerHTML = time;
         }
       }, 5 * 1000);
 
       return () => {
         //console.log('Clock() Stop interval');
         if (timer) {
           clearInterval(timer);
         }
       };
     },
     []
   );
 
   return (
     <div className="Clock" ref={dateRef} />
   );
   
 }
 
 export default Clock;
 